export default __webpack_public_path__ + "static/media/Artboard 3.878e61e5.png";